import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import { Box, Flex, Text } from 'rebass';
import { Action, Fab } from 'react-tiny-fab';
import '../../resources/css/fab.css';
import { Content, DesktopBox, MobileBox, MobileHeader, PositionBox, Toolbar } from "../../components/Base";
import { PageTitle } from "../../components/Base/Text";
import FacultyList from '../../components/FacultyList'
import ApplyFilter from '../../components/SearchFaculty/ApplyFilters'
import { ColumnIcon, GridIcon } from "../../components/Base/Icons";
import Loading from '../../components/Base/Loading';
import FilterDropdown from '../../components/SearchFaculty/FilterDropdown';
import WavePopup from '../../components/Wave/WavePopup';
import SearchFacultyInput from '../../components/Forms/SearchFacultyInput';
import FacultySummary from '../../components/FacultySummary';
import { AutoFocusInside } from "react-focus-lock";
import MdAdd from 'react-ionicons/lib/MdAdd';
import { SidebarBox, SidebarWrapper, Chat } from "./styles";
import { filterStudentsByName, returnFilterString } from "../../utils";

class SearchFaculty extends Component {

  state = {
    columnView: false,
    detailsView: false,
    currentStudent: null,
    leaves: [],
    searchTerm: '',
    newLeaves: [],
    pendingLeaves: [],
    searchResult: [],
    currentLeaves: null,
    checkin: false,
    wave: false,
    updated: false,
    updating: false,
    showWaveHistory: false,
    isCheckin: true,
    draftCheckIn: [],
    isLoading: false,
    confirmDelete: false,
    locationSearch: '',
  };

  componentDidMount() {
    this.fetchSchoolData();
  }

  fetchSchoolData = () => {
    const { school } = this.props;
    let schoolId = localStorage.getItem('school');
    try {
      if (schoolId) {
        const locations = {
          list: school.locations.list,
          map: school.locations.map
        };
        const leaves = {
          locations: locations
        };
        this.setState({ locationSearch: leaves });
      }
    } catch (e) {
    }
  }

  handleSelectStudent = async (details, isCheckin = false, selectedItems = []) => {
    const { width, history } = this.props;

    this.setState({
      isLoading: true
    })

    if (width < 700) {
      history.push(`/app/faculty-profile/${details.id}`)
    } else {
      try {
        this.setState({
          currentStudent: details,
          detailsView: true,
          isLoading: false,
        });
      } catch (err) {
      }
    }
  };

  handleWaveStudents = async (location) => {
    const { detailsView, currentStudent } = this.state;
    const { students, profile, isFaculty } = this.props;
    if (isFaculty) {
      try {
        if (detailsView === true) {
          if (!currentStudent.on_leave) {
            let studentRef = this.props.firebase.student(currentStudent.id);
            let waveRef = studentRef.collection('wave_history');

            let newWave = waveRef.doc();
            newWave.set({
              creator_uid: profile.id,
              location_is_geowave: false,
              location_uid: location,
              post_time: Math.floor(Date.now() / 1000)
            });
            studentRef.update({
              current_location: location
            });
            this.handleStudentSelect(currentStudent)
          }
        } else {
          for (let i in students) {
            if (!students[i].on_leave) {
              let studentRef = this.props.firebase.student(students[i].id);
              let waveRef = studentRef.collection('wave_history');

              let newWave = waveRef.doc();
              newWave.set({
                creator_uid: profile.id,
                location_is_geowave: false,
                location_uid: location,
                post_time: Math.floor(Date.now() / 1000)
              });
              studentRef.update({
                current_location: location
              })
            }
          }
        }

      } catch (err) {
      }
    }
  };

  setPageView = (isColumn) => {
    this.setState({ columnView: isColumn })
  };

  toggleDetailsView = () => {
    this.setState({ detailsView: !this.state.detailsView })
  };

  updateSearch = (e) => {
    const { updateSearch } = this.props;

    updateSearch(e.target.value)
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.search !== this.props.search) {
      if (this.state.detailsView === true) {
        this.setState({ detailsView: false })

      }
    }
  }

  render() {
    const { columnView, detailsView, wave } = this.state;

    const { schoolInfo, filters, clearFilter, history } = this.props;

    let showDetails = columnView;
    if (detailsView) {

      showDetails = true
    }
    if (columnView) {
      showDetails = true
    }

    if (localStorage.getItem("mobileProfile")) {
      return <Loading />;
    }


    return (
      <Box>

        <MobileHeader>
          <PageTitle color={'black'} pt={2}>{showDetails ? "Max's Profile" : "Search Faculties"}</PageTitle>
          <ApplyFilter
            school={schoolInfo}
            filters={JSON.parse(JSON.stringify(filters))}
            clearFilter={clearFilter}
            history={history}
            {...this.props}
          />
        </MobileHeader>


        {/* Mobile Search Input */}
        <Box ml={[0, '50%', '70%']}>
          <MobileBox>
            <PositionBox position={'fixed'} top={'114px'} width={1} zIndex={9999}>
              <SearchFacultyInput />
            </PositionBox>
          </MobileBox>
        </Box>

        <Content>

          {/* Checkin and Wave popups */}

          <WavePopup visible={wave} toggle={() => this.setState({ wave: false })}
            handleConfirm={this.handleWaveStudents} />

          {/* Student Summary Section for Desktop*/}

          {this.renderFacultySummary()}

        </Content>
      </Box>
    )
  }

  // ----------------------------
  // CHECKIN Functions and Renders
  // ----------------------------

  newFilterTitle = title => {
    let newText = '';
    if (newText === ', ' || newText === '') {
      return title;
    } else {
      if (title === 'All Faculties') {
        return newText.substr(2);
      } else {
        return title + newText;
      }
    }
  }

  handleChatRedirect = async () => {
    const { school, filters, history, width, updateCurrentChat, firebase, profile, search, students } = this.props;
    let filterTitle = returnFilterString(filters, school);

    if (this.newFilterTitle(filterTitle) !== 'All Faculties') {
      let newTitle = this.newFilterTitle(filterTitle).replace(/\s+/g, "").toLowerCase();
      let sortedTitle = newTitle.split(',').sort().join(',').replace(/[(),/]/g, "");
      let studentList = filterStudentsByName(students, search);
      let studentArr = [profile.id];

      studentList.forEach(obj => {
        studentArr.push(obj.id);
      });

      let chatTitle = this.newFilterTitle(filterTitle).replace(/-roster/g, '');

      try {
        let chatsRef = await firebase.chats().where('custom_id', '==', sortedTitle).get();
        let chatId;
        if (chatsRef.docs.length === 0) {
          const newChat = await firebase.chats().add({
						creator_uid: profile.id,
						is_group: true,
						name: chatTitle,
						members: studentArr,
						post_time: Math.floor(Date.now() / 1000),
						last_updated: Math.floor(Date.now() / 1000),
						messages: [],
						accepted: { status: 1, updated_at: Math.floor(Date.now() / 1000), members: studentArr },
						custom_id: sortedTitle
					});
					chatId = newChat.id;
        } else {
          chatId = chatsRef.docs[0].id;
        }
        if (width < 700) {
          history.push(`/app/chat/${chatId}`);
        } else {
          updateCurrentChat(chatId);
          history.push(`/app/chat`)
        }
      } catch (e) {
      }
    } else {
      history.push('/app/chat');
    }
  };

  renderFacultySummary = () => {
    const { currentStudent, columnView, detailsView, isLoading, locationSearch } = this.state;
    const { width, loading, students, search, profile, schoolInfo, filters, clearFilter, history } = this.props;

    let listProps = {
      width: [1, 1 / 4],
      mt: [0, 0],
    };

    if (!columnView) {
      listProps = {
        width: 1,
        mt: [0, 3]
      }
    }

    let showUserList = true;
    let showToolbar = true;
    let showDetails = columnView;
    if (detailsView) {
      showToolbar = false;
      showUserList = false;
      showDetails = true
    }
    if (columnView) {
      showToolbar = true;
      showUserList = true;
      showDetails = true
    }
    const showSummary = (width > 700 && showDetails);

    let searchList = filterStudentsByName(students, search);
    return (
      <Fragment>
        {this.renderFabButton()}

        {/* DESKTOP Toolbar with Filters and Column/Grid View*/}
        <DesktopBox>
          {showToolbar &&
            <Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>

              <Box css={{ display: 'inline-block' }} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
                color={'meta'}>VIEW</Text></Box>
              <Box bg={'transparent'} ml={3} py={2}
                onClick={() => this.setState({ columnView: false, detailsView: false })}>
                <GridIcon color={!columnView ? 'black' : '#969a9b'} />
              </Box>
              <Box ml={2} py={2} onClick={() => this.setState({ columnView: true })}>
                <ColumnIcon color={columnView ? '#00000' : '#969a9b'} />
              </Box>

              <Box css={{ display: 'inline-block' }} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
                color={'meta'}>FILTER</Text></Box>
              <Box ml={3}>
                <FilterDropdown
                  width={width}
                  school={schoolInfo}
                  filters={JSON.parse(JSON.stringify(filters))}
                  clearFilter={clearFilter}
                  history={history}
                  locationInfo={locationSearch !== '' ? locationSearch : []}
                />
              </Box>
              <Box css={{ display: 'inline-block' }} ml={3}>
                <SearchFacultyInput />
              </Box>
            </Toolbar>
          }
        </DesktopBox>

        {(loading || isLoading || localStorage.getItem("mobileProfile")) ? <Loading /> :

          <Flex width={1}>
            {showUserList &&
              <SidebarBox {...listProps} css={{ minWidth: '260px' }}>
                <SidebarWrapper boxShadow={['none', columnView ? 'inset' : 'none']} pb={[50, 0]} pt={[0, '10px']}>
                  <FacultyList students={searchList} handleUserClick={this.handleSelectStudent} 
                    columnView={columnView} current={currentStudent ? currentStudent.id : '1'} infiteScroll />
                </SidebarWrapper>
              </SidebarBox>}
            {console.log(currentStudent)}
            {showSummary ?
              <FacultySummary student={currentStudent} showBack={!showToolbar} isFaculty={true}
                handleBack={() => {
                  this.setState({ detailsView: false })
                }} profile={profile} />
              : <Box />
            }

          </Flex>}

      </Fragment>
    )
  }

  renderFabButton = () => {
    const { columnView, detailsView } = this.state;

    const { width } = this.props;

    let showDetails = columnView;
    if (detailsView) {

      showDetails = true
    }
    if (columnView) {

      showDetails = true
    }
    const showSummary = (width > 700 && showDetails);


    let showFab = false
    if (!columnView && showSummary) {
      showFab = false
    }

    return (
      <Fragment>
        {showFab &&

          <Fab
            mainButtonStyles={{ marginBottom: '50px', backgroundColor: '#FFC61A', width: '47px', height: '47px' }}
            icon={<AutoFocusInside><MdAdd color={'white'} /></AutoFocusInside>}
            event={'click'}
            actionButtonStyles={{ color: 'black' }}
          >
            <Action
              text='Chat'
              onClick={this.handleChatRedirect}
            >
              <Chat />
            </Action>
          </Fab>}
      </Fragment>
    )
  }
}

export default withRouter(SearchFaculty);
